import { createStore } from 'vuex'
import loginSms from './loginSms'
import userInfo from './userInfo'
import user from './user'
import total from './total'
export default createStore({
	modules: {
		// user,
		// userInfo,
		// loginSms
	},
	getters: {
		// showInfo: (state) => state.userInfo.showInfo,
		// infoData: (state) => state.userInfo.infoData,
		// infoFormData: (state) => state.userInfo.infoFormData,
		// token: (state) => state.user.token,
		// userInfo: (state) => state.user.userInfo,
		// wait: (state) => state.loginSms.wait,
		// total: (state) => state.user.total
	}
})
